import * as React from "react";
import { Text, Button, makeStyles, tokens } from "@fluentui/react-components";
import { Bot48Regular, Add24Regular } from "@fluentui/react-icons";
import { useTypographyStyles } from "../../../styles/typography.styles";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacingVerticalXXXL,
    textAlign: "center",
    gap: tokens.spacingVerticalM,
  },
  icon: {
    fontSize: "48px",
    color: tokens.colorNeutralForeground3,
  },
  description: {
    color: tokens.colorNeutralForeground2,
    maxWidth: "400px",
  },
});

interface TaskEmptyStateProps {
  hasFilters: boolean;
  onCreateClick?: () => void;
}

const TaskEmptyState: React.FC<TaskEmptyStateProps> = ({
  hasFilters,
  onCreateClick,
}) => {
  const styles = useStyles();
  const typography = useTypographyStyles();

  if (hasFilters) {
    return (
      <div className={styles.container}>
        <Bot48Regular className={styles.icon} />
        <Text className={typography.emptyStateTitle}>
          No agents match your filters
        </Text>
        <Text className={styles.description}>
          Try adjusting your search or filter criteria to find what you're
          looking for.
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Bot48Regular className={styles.icon} />
      <Text className={typography.emptyStateTitle}>
        No agents yet
      </Text>
      <Text className={styles.description}>
        Agents will appear here when they are created. Agents are AI-driven
        operations that can be executed automatically.
      </Text>
      {onCreateClick && (
        <Button
          appearance="primary"
          icon={<Add24Regular />}
          onClick={onCreateClick}
        >
          Run Agent
        </Button>
      )}
    </div>
  );
};

export default TaskEmptyState;
